export const municipality = {
  name: `municipality`,
  sql: `
    SELECT * FROM solano_jurisdictions
    `,
  cartoCSS: `
    #layer {
      polygon-fill: #1c58ff;
      polygon-opacity: 0;
    }
    #layer::outline {
      line-width: 1;
      line-color: #0043ff;
      line-opacity: 1;
    }
  `,
  viz: `
    color: opacity(#0043ff, 0)
    strokeColor: #0043ff
  `
}